export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_3.2f10b05c.png";